import { Box, DashboardModule, Form } from '@domain-group/suit-theme'

import PortalDataInput from '../PortalDataInput'

const ListingCategory = () => (
  <DashboardModule boxProps={{ flexDirection: 'column', marginBottom: 'large' }} title="Category">
    <Form padding="large">
      <Form.Row>
        <PortalDataInput fieldKey="listingType" />

        <Box marginTop={['large', 0]}>
          <PortalDataInput fieldKey="category" />

          <PortalDataInput fieldKey="commercialCategory" />

          <PortalDataInput fieldKey="ruralCategory" />
        </Box>
      </Form.Row>
    </Form>
  </DashboardModule>
)

export default ListingCategory
